import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {validToken} from "../helpers/helperJWT";
import {useSelector} from "react-redux";

function PublicRoute({ component: Component, roles, ...rest }) {

    const authState = useSelector(state => state?.auth);

    return (
        <Route {...rest} render={props => {

            const infoToken = validToken(authState?.token);
            const {error} = infoToken;

            if(error){
                return <Component {...props} />
            }

            return <Redirect to={{ pathname: '/', state: { from: props.location } }} />

        }} />
    );
}

export { PublicRoute };
